import React from "react";
import { useEffect } from "react";
import ReactECharts from 'echarts-for-react';
import { useSelector, useDispatch } from "react-redux";
import { fetchAllOrdersThunk } from "../../../Slices/orderSlice";
import { Typography } from "antd";

const RequestsStats = () => {
    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
    const dispatch=useDispatch();
//     
    useEffect(() => {
       dispatch(fetchAllOrdersThunk({id: loginUser.id }));
}, [dispatch,loginUser.id]);



    const summary = useSelector((state) => state.orders.summary);
    if (!summary?.inbox) return <div>Loading...</div>;
    
    const getAvailableOnDemandMonthly = summary?.inbox?.getAvailableOnDemandMonthly;
    const getInprogressOnDemandMonthly = summary?.inbox?.getInprogressOnDemandMonthly;
    const getOnholdOnDemandMonthly = summary?.inbox?.getOnholdOnDemandMonthly;

    const getAvailableRushMonthly = summary?.inbox?.getAvailableRushMonthly;
    const getInprogressRushMonthly = summary?.inbox?.getInprogressRushMonthly;
    const getOnholdRushMonthly = summary?.inbox?.getOnholdRushMonthly;
  
    const getAvailableBulkMonthly = summary?.inbox?.getAvailableBulkMonthly;
    const getInprogressBulkMonthly = summary?.inbox?.getInprogressBulkMonthly;
    const getOnholdBulkMonthly = summary?.inbox?.getOnholdBulkMonthly;

    const getEmailNeededOnDemandMonthly = summary?.emailNeeded?.getEmailNeededOnDemandMonthly;
    const getEmailNeededRushMonthly = summary?.emailNeeded?.getEmailNeededRushMonthly;
    const getEmailNeededBulkMonthly = summary?.emailNeeded?.getEmailNeededBulkMonthly;
    
    const getPendingsOnDemandMonthly = summary?.pending?.getPendingsOnDemandMonthly;
    const getPendingsRushMonthly = summary?.pending?.getPendingsRushMonthly;
    const getPendingsBulkMonthly = summary?.pending?.getPendingsBulkMonthly;    

    // Cancelled requests match none of the buckets above, so without this
    // block they would be absent from every chart on the page with nothing
    // indicating they exist. Charted alongside the rest instead.
    const getCancelledOnDemandMonthly = summary?.cancelled?.getCancelledOnDemandMonthly;
    const getCancelledRushMonthly = summary?.cancelled?.getCancelledRushMonthly;
    const getCancelledBulkMonthly = summary?.cancelled?.getCancelledBulkMonthly;

    const getDiscardOnDemandMonthly = summary?.discard?.getDiscardOnDemandMonthly;
    const getDiscardRushMonthly = summary?.discard?.getDiscardRushMonthly;
    const getDiscardBulkMonthly = summary?.discard?.getDiscardBulkMonthly;    

    const getCompletedThisMonthOnDemand = summary?.completed?.getCompletedThisMonthOnDemand;
    const getCompletedThisMonthRush = summary?.completed?.getCompletedThisMonthRush;
    const getCompletedThisMonthBulk = summary?.completed?.getCompletedThisMonthBulk;

    const getInstructionsOnDemandMonthly = summary?.instructions?.getInstructionsOnDemandMonthly;
    const getInstructionsRushMonthly = summary?.instructions?.getInstructionsRushMonthly;
    const getInstructionsBulkMonthly = summary?.instructions?.getInstructionsBulkMonthly;
    const totalInstructionsCount = getInstructionsOnDemandMonthly + getInstructionsRushMonthly + getInstructionsBulkMonthly;
    

    const getAllMonths = () => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const currentMonth = new Date().getMonth();
        const currentYear = new Date().getFullYear();
       
        const monthsData = [];
        for (let i = 0; i < 12; i++) {
            const rawMonthIndex = currentMonth - i;
            const monthIndex = (rawMonthIndex + 12) % 12;
            const year = rawMonthIndex < 0 ? currentYear - 1 : currentYear;
            const key = `${year}-${String(monthIndex + 1).padStart(2, '0')}`;
            monthsData.unshift({ key, label: `${months[monthIndex]} ${year}` });
            }
        return monthsData;
    };
    const monthsData = getAllMonths(); 


    const allMonthlyArrays = [
        getAvailableOnDemandMonthly,
        getInprogressOnDemandMonthly,
        getOnholdOnDemandMonthly,
        getAvailableRushMonthly,
        getInprogressRushMonthly,
        getOnholdRushMonthly,
        getAvailableBulkMonthly,
        getInprogressBulkMonthly,
        getOnholdBulkMonthly
    ];
    /*
     * Every monthly bucket on this page reads an OPTIONAL field off `summary`.
     * Any one of them being absent — an older or newer backend, a partial
     * response, a failed fetch leaving `summary` as {} — used to throw on
     * `array.forEach` and white-screen the entire stats page.
     *
     * One guarded accumulator, used by every bucket below, so adding another
     * bucket cannot reintroduce the crash. Entries with no month are skipped
     * (they only ever produced a `totals[undefined]` key nothing reads) and
     * counts are coerced, so a string count sums instead of concatenating.
     */
    const sumMonthly = (arrays) => {
        const totals = {};
        (arrays || []).forEach(array => {
          (array || []).forEach((entry) => {
            const { month, count } = entry || {};
            if (!month) return;
            if (!totals[month]) totals[month] = 0;
            totals[month] += Number(count) || 0;
          });
        });
        return totals;
    };
    const buildMonthlyData = (arrays, label) => ({ [label]: sumMonthly(arrays) });

    const monthlyTotals = sumMonthly(allMonthlyArrays);

    // Map to chart data
    const xLabels = monthsData.map(m => m.label);
    const yValues = monthsData.map(m => monthlyTotals[m.key] || 0);


    // Set up the Inbox Monthly Bar Graph Data
    const InboxMonthlyBarData = {
        xAxis: {
            type: 'category',
            data: xLabels, // Use the months dynamically
            axisLabel: {
                interval: 0, // Show all labels (ensure all months are visible)
                rotate: 45,  // Rotate labels if necessary for better visibility
            }
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: yValues,
                type: 'bar',
                barWidth: '80%',  // Adjust bar width
                itemStyle: {
                    color: "#36b9cc"
                },
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}'  
                }
            }
        ]
    };

    const InboxMonthlyBarOptions = {
        title: {
            text: 'Total Requests',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },
        xAxis: InboxMonthlyBarData.xAxis,
        yAxis: InboxMonthlyBarData.yAxis,
        series: InboxMonthlyBarData.series,
    };



    const buildPriorityData = buildMonthlyData;
    const priorityMonthlyData = {
        ...buildPriorityData([
          getAvailableOnDemandMonthly,
          getInprogressOnDemandMonthly,
          getOnholdOnDemandMonthly
        ], 'On Demand'),
        ...buildPriorityData([
          getAvailableRushMonthly,
          getInprogressRushMonthly,
          getOnholdRushMonthly
        ], 'Rush'),
        ...buildPriorityData([
          getAvailableBulkMonthly,
          getInprogressBulkMonthly,
          getOnholdBulkMonthly
        ], 'Bulk')
    };
      
    const grid = {
        left: 100,
        right: 100,
        top: 50,
        bottom: 50
    };
 
    const InboxMonthlyBarDataPriority = {
        legend: {
            selectedMode: false
          },

        yAxis: {
            type: 'value'
        },
        xAxis: {
            type: 'category',
            data:  xLabels,
            axisLabel: {
                interval: 0,
                rotate: 45,  
            }
        }, 
        grid,
        series : ['On Demand', 'Rush', 'Bulk'].map(priority => {
            return {
                name: priority,
                type: 'bar',    
                stack: 'total',
                barWidth: '80%',
                label: {
                    show: true,
                    // position: 'top',
                    formatter: (params) => Math.round(params.value * 10) / 10,
                },
                    data: monthsData.map(m => priorityMonthlyData[priority]?.[m.key] || 0)
            };
        })
    };
    
    const InboxMonthlyBarOptionsPriority = {
        title: {
            text: 'Inbox Priority Wise',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },

        legend: {
            data: ['On Demand', 'Rush', 'Bulk'],
            orient: 'horizontal', 
            top: '93%', 
            left: 'center' 
          },
        xAxis: InboxMonthlyBarDataPriority.xAxis,
        yAxis: InboxMonthlyBarDataPriority.yAxis,
        series: InboxMonthlyBarDataPriority.series
    };    



    const buildCompletedData = buildMonthlyData;  
    const completedMonthlyData = {
        ...buildCompletedData([
            getCompletedThisMonthOnDemand,   
        ], 'On Demand'),
        ...buildCompletedData([
            getCompletedThisMonthRush,
        ], 'Rush'),
        ...buildCompletedData([
            getCompletedThisMonthBulk
        ], 'Bulk')
    };
   
    const InboxMonthlyBarDataCompleted = {
        legend: {
            selectedMode: false
          },

        yAxis: {
            type: 'value'
        },
        xAxis: {
            type: 'category',
            data:  xLabels,
            axisLabel: {
                interval: 0,
                rotate: 45,  
            }
        }, 
        grid,
        series : ['On Demand', 'Rush', 'Bulk'].map(priority => {
            return {
                name: priority,
                type: 'bar',    
                stack: 'total',
                barWidth: '80%',
                label: {
                    show: true,
                    // position: 'top',
                    formatter: (params) => Math.round(params.value * 10) / 10,
                },
                    data: monthsData.map(m => completedMonthlyData[priority]?.[m.key] || 0)
            };
        })
    };
    
    const InboxMonthlyBarOptionsCompleted = {
        title: {
            text: 'Completed',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },

        legend: {
            data: ['On Demand', 'Rush', 'Bulk'],
            orient: 'horizontal', 
            top: '93%', 
            left: 'center' 
          },
        xAxis: InboxMonthlyBarDataCompleted.xAxis,
        yAxis: InboxMonthlyBarDataCompleted.yAxis,
        series: InboxMonthlyBarDataCompleted.series
    };    



    const allPendingMonthlyArrays = [
        getPendingsOnDemandMonthly,
        getPendingsRushMonthly,
        getPendingsBulkMonthly
    ];
    const pendingMonthlyTotals = sumMonthly(allPendingMonthlyArrays);

    // Map to chart data
    const yPendingValues = monthsData.map(m => pendingMonthlyTotals[m.key] || 0);

    
    const InboxMonthlyBarDataPedings = {
        xAxis: {
            type: 'category',
            data: xLabels,
            boundaryGap: true,
            axisLabel: {
                interval: 0,  // Rotate the labels if necessary
                rotate: 45,  // Adjust the angle for better visibility
            }
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: yPendingValues,
                type: 'bar',
                position: 'left',
                barWidth: '80%',
                itemStyle: {
                    color: '#36b9cc'
                },
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}'  // Show data values at the top of bars
                }
            }
        ]
    };

    const InboxMonthlyBarOptionsPendins = {
        title: {
            text: 'Pendings',
            //left: 'center',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },
        xAxis: InboxMonthlyBarDataPedings.xAxis,
        yAxis: InboxMonthlyBarDataPedings.yAxis,
        series: InboxMonthlyBarDataPedings.series,
    };




    const buildEmailNeededData = buildMonthlyData;  
    const emailNeededMonthlyData = {
        ...buildEmailNeededData([
            getEmailNeededOnDemandMonthly,   
        ], 'On Demand'),
        ...buildEmailNeededData([
            getEmailNeededRushMonthly,
        ], 'Rush'),
        ...buildEmailNeededData([
            getEmailNeededBulkMonthly
        ], 'Bulk')
    };

    const InboxMonthlyBarDataEmailNeeded = {
        xAxis: {
            type: 'category',
            data: xLabels,
            axisLabel: {
                interval: 0,  // Rotate the labels if necessary
                rotate: 45,  // Adjust the angle for better visibility
            }
        },
        yAxis: {
            type: 'value',
        },
        grid,
        series : ['On Demand','Rush','Bulk'].map((priority) => {
         return {
           name: priority,
           type: 'bar',
           stack: 'total',
           barWidth: '80%',
           label: {
             show: true,
             formatter: (params) => Math.round(params.value * 10) / 10 
           },
           data: monthsData.map(m => emailNeededMonthlyData[priority]?.[m.key] || 0)
         };
       })         
    };

    const InboxMonthlyBarOptionsEmailNeeded = {
        title: {
            text: 'Email Needed',
            //left: 'center',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },
    
        legend: {
            data: ['On Demand', 'Rush', 'Bulk'],
            orient: 'horizontal', 
            top: '93%', 
            left: 'center' 
          },
        xAxis: InboxMonthlyBarDataEmailNeeded.xAxis,
        yAxis: InboxMonthlyBarDataEmailNeeded.yAxis,
        series: InboxMonthlyBarDataEmailNeeded.series,
    };


    const buildDiscardData = buildMonthlyData;
    const discardMonthlyData = {
        ...buildDiscardData([
            getDiscardOnDemandMonthly,   
        ], 'On Demand'),
        ...buildDiscardData([
            getDiscardRushMonthly,
        ], 'Rush'),
        ...buildDiscardData([
            getDiscardBulkMonthly
        ], 'Bulk')
    };

    const InboxMonthlyBarDataDiscard = {
        xAxis: {
            type: 'category',
            data: xLabels,
            axisLabel: {
                interval: 0,  // Rotate the labels if necessary
                rotate: 45,  // Adjust the angle for better visibility
            }
        },
        yAxis: {
            type: 'value',
        },
        series : [
            'On Demand',
            'Rush',
            'Bulk'
        ].map((priority) => {
             return {
               name: priority,
               type: 'bar',
               stack: 'total',
               barWidth: '80%',
               label: {
                 show: true,
                 formatter: (params) => Math.round(params.value * 10) / 10 
               },
               data: monthsData.map(m => discardMonthlyData[priority]?.[m.key] || 0) 
             };
        })       
    };

    // `|| []` guards the render if the backend hasn't been restarted with the
    // cancelled bucket yet — buildDiscardData iterates unguarded, so an
    // undefined array would white-screen the whole stats page.
    const cancelledMonthlyData = {
        ...buildDiscardData([getCancelledOnDemandMonthly || []], 'On Demand'),
        ...buildDiscardData([getCancelledRushMonthly || []], 'Rush'),
        ...buildDiscardData([getCancelledBulkMonthly || []], 'Bulk')
    };

    const InboxMonthlyBarDataCancelled = {
        xAxis: InboxMonthlyBarDataDiscard.xAxis,
        yAxis: InboxMonthlyBarDataDiscard.yAxis,
        series : [
            'On Demand',
            'Rush',
            'Bulk'
        ].map((priority) => {
             return {
               name: priority,
               type: 'bar',
               stack: 'total',
               barWidth: '80%',
               label: {
                 show: true,
                 formatter: (params) => Math.round(params.value * 10) / 10
               },
               data: monthsData.map(m => cancelledMonthlyData[priority]?.[m.key] || 0)
             };
        })
    };

    const InboxMonthlyBarOptionsCancelled = {
        title: {
            text: 'Cancelled',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },
        legend: {
            data: ['On Demand', 'Rush', 'Bulk'],
            orient: 'horizontal',
            top: '93%',
            left: 'center'
          },
        xAxis: InboxMonthlyBarDataCancelled.xAxis,
        yAxis: InboxMonthlyBarDataCancelled.yAxis,
        series: InboxMonthlyBarDataCancelled.series,
    };

    const InboxMonthlyBarOptionsDiscard = {
        title: {
            text: 'Discard',
            //left: 'center',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },
            legend: {
            data: ['On Demand', 'Rush', 'Bulk'],
            orient: 'horizontal', 
            top: '93%', 
            left: 'center' 
          },
        xAxis: InboxMonthlyBarDataDiscard.xAxis,
        yAxis: InboxMonthlyBarDataDiscard.yAxis,
        series: InboxMonthlyBarDataDiscard.series,
    };


    const InboxMonthlyBarDataInstructions = {
        xAxis: {
            type: 'category',
            data: ['May 2025'],
            
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: [totalInstructionsCount],
                type: 'bar',
                barWidth: '20%',  // Adjust bar width
                itemStyle: {
                    color: '#36b9cc'
                },
                label: {
                    show: true,
                    position: 'top',
                    formatter: '{c}'  // Show data values at the top of bars
                }
            }
        ]
    };

    const InboxMonthlyBarOptionsInstructions = {
        title: {
            text: 'Instructions',
            //left: 'center',
            textStyle: {
                fontWeight: 'bold',
                fontSize: 18,
                color: '#000000'
            }
        },
       
        xAxis: InboxMonthlyBarDataInstructions.xAxis,
        yAxis: InboxMonthlyBarDataInstructions.yAxis,
        series: InboxMonthlyBarDataInstructions.series,
    };


    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <Typography style={{ marginBottom: "20px", fontWeight: 'bold' }}>Requests Dashboard</Typography>
                <div className="row">
                    {/* First Card */}
                    <div className="col-md-12 col-sm-12">
                        <div className="card-group">
                            <div className="card">

                                <div className="card-body">

                                    <h3 style={{ fontWeight: 'bold', color: 'black' }}>Current Month Details</h3>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptions} />
                                        </div>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsPriority} />
                                        </div>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsCompleted} />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {/* Second Card */}
                    <div className="col-md-12 col-sm-12">
                        <div className="card-group m-b-30">
                            <div className="card">

                                <div className="card-body">

                                    <div style={{ display: 'flex' }}>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsPendins} />
                                        </div>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsEmailNeeded} />
                                        </div>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsDiscard} />
                                        </div>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsCancelled} />
                                        </div>
                                        <div style={{ height: "300px", width: "400px" }}>
                                            <ReactECharts option={InboxMonthlyBarOptionsInstructions} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RequestsStats